@if(noCustomerRegistered || isWhiteLabel){
    <div class="sx-registration-pane">
        <!-- Ej Förvaltare - inga kunder  -->
        @if(!isManger && !isWhiteLabel){
            <app-system-message
                [isVisible]="true" 
                [isDismissable]="false" 
                [severity]="2">
                <span>{{ 'registration.no_customer_message' | translate}}</span>
                <a href="#" [routerLink]="['/secure/register/additional']">
                    {{'registration.no_customer_link'| translate}}
                </a>{{'registration.no_customer_link_text'|translate}}
            </app-system-message>
        }

        <!-- Förvaltare - inga förvaltarbolag   -->
        @if(isManger && !isWhiteLabel && noOfManagerCompanies === 0){
            <app-system-message
                [isVisible]="true" 
                [isDismissable]="false" 
                [severity]="2" >
                <span>{{ 'registration.no_manager_company_message' | translate}}</span>
                <a  href="javascript:void(0)" (click)="navigateToManagerAdmin()">
                    {{ 'registration.no_customer_link' | translate}}
                </a>{{ 'registration.no_customer_link_text' | translate}}
            </app-system-message>
        }

        <!-- Förvaltare - inga kunder   -->
         @if(isManger && !isWhiteLabel && noOfManagerCompanies > 0){
            <app-system-message
                [isVisible]="true"
                [isDismissable]="false" 
                [severity]="2" >
                <span>{{ 'registration.no_customer_message' | translate}}</span>
                <span>
                    <a href="javascript:void(0)" (click)="navigateToManagerAdmin()">
                        {{'registration.no_customer_link'|translate}}
                    </a>{{'registration.no_customer_link_text'|translate}}
                </span>
            </app-system-message>
         }
    </div>
}

<!-- Ej Förvaltare - har kunder men inga anläggningar -->
 @if(!isManger && !noCustomerRegistered && noMeteringPointOnRegisteredCustomers){
    <div class="sx-registration-pane">
        <app-system-message 
            [isVisible]="true" 
            [isDismissable]="false" 
            [severity]="2" >
            <span>{{ 'registration.no_meteringpoints_message' | translate }}</span>
            <span>
                <a href="javascript:void(0)" (click)="openSupportPage()">
                    {{'registration.no_metering_point_link'|translate}}
                </a>{{'registration.no_metering_point_link_text'|translate}}
            </span>
        </app-system-message>
    </div>
 }

<!-- Förvaltare - har kunder men inga anläggningar -->
@if(isManger && !noCustomerRegistered && noAccessToMeteringPoints){
    <div class="sx-registration-pane">
        <app-system-message 
            [isVisible]="true" 
            [isDismissable]="false" 
            [severity]="2" >
            <span>{{ 'registration.no_access_message' | translate}}</span>
            <a href="javascript:void(0)" (click)="navigateToManagerAdmin()">
                {{ 'registration.no_access_link' | translate}}
            </a>
        </app-system-message>
    </div>
}
